import React from 'react';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const LanguageSelection = ({ selectedLanguage, onLanguageSelect }) => {
  const { t, changeLanguage } = useLanguage();

  const languages = [
    {
      id: 'en',
      code: 'en-US',
      label: t('onboarding.english'),
      description: t('onboarding.englishDesc'),
      icon: 'Globe'
    },
    {
      id: 'fr',
      code: 'fr-CA',
      label: t('onboarding.french'),
      description: t('onboarding.frenchDesc'),
      icon: 'Globe'
    },
    {
      id: 'bilingual',
      code: 'en-US',
      label: t('onboarding.bilingual'),
      description: t('onboarding.bilingualDesc'),
      icon: 'Languages'
    }
  ];

  const handleLanguageSelect = (language) => {
    onLanguageSelect(language?.id);
    if (language?.id === 'fr') {
      changeLanguage('fr-CA');
    } else {
      changeLanguage('en-US');
    }
  };

  return (
    <div className="w-full">
      <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground mb-2">
        {t('onboarding.languageTitle')}
      </h2>
      <p className="text-sm md:text-base lg:text-lg text-muted-foreground mb-6 md:mb-8">
        {t('onboarding.languageSubtitle')}
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {languages?.map((language) => (
          <button
            key={language?.id}
            onClick={() => handleLanguageSelect(language)}
            className={`w-full min-w-0 p-6 md:p-8 rounded-2xl border-2 transition-all duration-250 text-left ${
              selectedLanguage === language?.id
                ? 'border-primary bg-primary/5' :'border-border bg-card hover:border-primary/50'
            }`}
          >
            <div className="flex items-start gap-4">
              <div
                className={`w-12 h-12 md:w-14 md:h-14 rounded-xl flex items-center justify-center flex-shrink-0 ${
                  selectedLanguage === language?.id
                    ? 'bg-primary text-primary-foreground'
                    : 'bg-muted text-muted-foreground'
                }`}
              >
                <Icon name={language?.icon} size={24} />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-lg md:text-xl font-semibold text-foreground mb-1">
                  {language?.label}
                </h3>
                <p className="text-sm md:text-base text-muted-foreground">
                  {language?.description}
                </p>
              </div>
              {selectedLanguage === language?.id && (
                <Icon name="Check" size={20} color="var(--color-primary)" />
              )}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default LanguageSelection;